import "./App.css";
import { HashRouter as Router, Routes, Route } from "react-router-dom";

// import Testing from "./Pages/Testing"
import Home from "./Home";
import TermsCondition from "./Pages/Policies/TermsCondition";
import CookiesPolicy from "./Pages/Policies/CookiesPolicy";
import PrivacyPolicy from "./Pages/Policies/PrivacyPolicy";


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/testing" element={<Testing />} /> */}
        {/* <Route path="it-solution" element={<MainITSolutionHero />} /> */}
        <Route path="policies/terms-conditions" element={<TermsCondition />} />
        <Route path="policies/cookies" element={<CookiesPolicy />} />
        <Route path="policies/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
}

export default App;
